export default class AppRoutes {
    static HomeScreenRoute = "/";
    static ProjectScreenRoute = "/project";
}
